export enum UiPermission {
  SHOW_PAYMENT_BTN = 'showPaymentBtn',
  SHOW_REFUSE_ACCEPT_BTN = 'showRefuseAcceptBtn',
  SHOW_QR_SCANNER_BTN = 'showScanQRBtn',
  CAN_UPDATE_FIELDS = 'canUpdateFields',
  CAN_UPDATE_FIELD_AS_BORDER = 'canUpdateFieldAsBorder',
  SHOW_CLOSE_APP_BTN = 'showCloseAppBtn',
  IS_NUMBER_APPLICATION_VISIBLE = 'isNumberApplicationVisible',
  IS_STATUS_PAID_FOR_PRINT = 'isStatusPaidForPrint',
  EVALUATE_CAN_BEREVIEWED_ADMIN = 'evaluateCanBeReviewedAdmin',
  CAN_UPDATE_DOC = 'canUpdateDoc',
  SHOW_ENTRY_REGISTER_BTN = 'showEntryRegisterBtn',
  ALLOW_DUPLICATE_PAYMENT = 'allowDuplicatePayment',
  CAN_UPDATE_NNI = 'canUpdateNNI',
  SHOULD_LOAD_DETAILED_PAYMENT_DATA = 'shouldLoadDetailedPaymentData',
  CAN_LOAD_INBOUND = 'canLoadInbound',
  CAN_LOAD_FULLMETADATA = 'canLoadFullMetadata',
  SHOW_PRINT_APPROVAL_LETTER = 'showPrintApprovalLetter',
  SHOW_HQ_REFERENCE_BTN = 'showHqReferenceBtn',
  SHOW_SET_TIMESLOT_BTN = 'showSetTimeslotBtn'
}
